











































































import { Component, Vue } from 'vue-property-decorator';
import CoreFooter from '@/components/core/Footer.vue';

import AppStore from '@/store/App';

import { RpcEvent } from '@/events';

@Component({
  components: {
    CoreFooter,
  }
})
export default class CoreView extends Vue {
  get snackbar() { return AppStore.snackVisible; }
  set snackbar( val: boolean ) { val ? AppStore.SHOW_SNACK() : AppStore.HIDE_SNACK(); }
  get snackMessage() { return AppStore.snackMessage; }
  get snackColor() { return AppStore.snackColor; }
  get snackIcon() { return AppStore.snackIcon; }

  get dialog() { return AppStore.dialogVisible; }
  set dialog( val: boolean ) { val ? AppStore.SHOW_DIALOG() : AppStore.HIDE_DIALOG(); }
  get dialogMessage() { return AppStore.dialogMessage; }
  get dialogCaption() { return AppStore.dialogCaption; }
  get dialogMode() { return AppStore.dialogMode; }

  onNo() {
    AppStore.RESOLVE_DIALOG_PROMISE(false);
    AppStore.HIDE_DIALOG();
  }
  onYes() {
    AppStore.RESOLVE_DIALOG_PROMISE(true);
    AppStore.HIDE_DIALOG();
  }

    mounted() {
        RpcEvent.on('error', (err: Error) => {
            const message: string = `APIエラー: ${err.name} ${err.message}`;
            AppStore.showError(message);
        })
    }
}
